var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"src_select_btn album"},[_c('div',{staticClass:"src_select_btn__before",style:({paddingTop: _vm.aspectRatioStyle})}),_c('div',{staticClass:"btn__wrapper"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }